<div class="div-flex-row-space-around">
  <mat-card class="title">{{ 'welcome' | translate }}</mat-card>    
</div>
